module.exports = "pegasus_template/assets/header-fall-default-1.jpg";